import { render, staticRenderFns } from "./AddCampaignWidget.vue?vue&type=template&id=53729d03&scoped=true&"
import script from "./AddCampaignWidget.vue?vue&type=script&lang=js&"
export * from "./AddCampaignWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53729d03",
  null
  
)

export default component.exports